var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.54 21.55C26.12 21.96 25.88 22.55 25.94 23.18C26.03 24.26 27.02 25.05 28.1 25.05H30V26.24C30 28.31 28.31 30 26.24 30H16.13C16.44 29.74 16.71 29.42 16.92 29.06C17.29 28.46 17.5 27.75 17.5 27C17.5 24.79 15.71 23 13.5 23C12.56 23 11.69 23.33 11 23.88V19.51C11 17.44 12.69 15.75 14.76 15.75H26.24C28.31 15.75 30 17.44 30 19.51V20.95H27.98C27.42 20.95 26.91 21.17 26.54 21.55Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.4101V15.8401C11 14.6501 11.73 13.5901 12.84 13.1701L20.78 10.1701C22.02 9.70006 23.35 10.6201 23.35 11.9501V15.7501",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0588 21.9702V24.0302C31.0588 24.5802 30.6188 25.0302 30.0588 25.0502H28.0988C27.0188 25.0502 26.0288 24.2602 25.9388 23.1802C25.8788 22.5502 26.1188 21.9602 26.5388 21.5502C26.9088 21.1702 27.4188 20.9502 27.9788 20.9502H30.0588C30.6188 20.9702 31.0588 21.4202 31.0588 21.9702Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20H22.5",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 27C17.5 27.75 17.29 28.46 16.92 29.06C16.71 29.42 16.44 29.74 16.13 30C15.43 30.63 14.51 31 13.5 31C12.04 31 10.77 30.22 10.08 29.06C9.71 28.46 9.5 27.75 9.5 27C9.5 25.74 10.08 24.61 11 23.88C11.69 23.33 12.56 23 13.5 23C15.71 23 17.5 24.79 17.5 27Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9414 26.9995L12.9314 27.9895L15.0614 26.0195",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.7f25b3c1e1159a2ed193853ab0928d91.svg";
export { ForwardRef as ReactComponent };